/**
 * Cookie de sesion de GA4 que viaja al checkout de Stripe (VEX-7051).
 *
 * El `purchase` de Stripe lo manda el backend por Measurement Protocol, y sin
 * `session_id` GA4 no lo une a la sesion del navegador: llega con origen/medio
 * `(not set)`. El id de sesion vive en la cookie `_ga_<id del flujo>`.
 *
 * Tiene que ser la del flujo G-DTVMVMNNFE, el mismo al que manda el backend
 * (ENV_GA4_MEASUREMENT_ID): la sesion de otro flujo no une con nada. Por eso el
 * nombre va fijo y no se busca "la primera `_ga_*`" (ver VEX-6457, dos flujos
 * midiendo el sitio a la vez).
 *
 * Se manda la cookie CRUDA, como `_ga`: el formato cambio de GS1 a GS2 y el
 * recorte lo hace el backend (Ga4MeasurementProtocol::normalizeSessionId).
 */
export const GA4_SESSION_COOKIE = '_ga_DTVMVMNNFE';

export const gaSessionCookie = (cookies) =>
  (cookies && cookies.get(GA4_SESSION_COOKIE)) || undefined;

export default gaSessionCookie;
